(function () {
  'use strict';

  function initStockBySizePage() {
    var root = document.getElementById('stock-by-size');
    if (!root || root.dataset.sbsInitialized === 'true') return;
    root.dataset.sbsInitialized = 'true';

    var GROUPS = [
      { key: 'u22', test: function (s) { return s <= 22; } },
      { key: '225-230', test: function (s) { return s >= 22.5 && s <= 23; } },
      { key: '235-240', test: function (s) { return s >= 23.5 && s <= 24; } },
      { key: 'o245', test: function (s) { return s >= 24.5; } }
    ];

    var EXCLUDED_TITLE_WORDS = ['予約', '受注', '売切', 'サンプルセール', 'ビジュー', '着せ替え用ヒール', 'ソックス', 'レッグウォーマー'];
    var EXCLUDED_TAGS = ['sample_sale', 'on_sample_sale', 'preorder', 'pre-order', '予約', '予約販売', '受注', '26awmrj'];

    function norm(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    }

    function isExcluded(product) {
      var title = norm(product.title);
      var tags = Array.isArray(product.tags)
        ? product.tags.map(norm)
        : String(product.tags || '').split(',').map(norm);

      return EXCLUDED_TITLE_WORDS.some(function (word) {
        return title.indexOf(norm(word)) !== -1;
      }) || EXCLUDED_TAGS.some(function (tag) {
        return tags.indexOf(norm(tag)) !== -1;
      });
    }

    function sizeOptionIndex(product) {
      var options = Array.isArray(product.options) ? product.options : [];
      for (var i = 0; i < options.length; i += 1) {
        var optionName = norm(options[i] && options[i].name ? options[i].name : options[i]);
        if (optionName.indexOf('サイズ') !== -1 || optionName === 'size' || optionName.indexOf('shoe size') !== -1) {
          return i;
        }
      }
      return -1;
    }

    function parseSize(variant, index) {
      var raw = '';
      if (index >= 0) {
        if (Array.isArray(variant.options)) raw = variant.options[index] || '';
        if (!raw) raw = variant['option' + (index + 1)] || '';
      }
      if (!raw) raw = variant.title || '';

      var match = String(raw)
        .replace('．', '.')
        .match(/(?:^|[^0-9])(1[89]|2[0-9])(?:\.(0|5))?(?:\s*cm)?(?:$|[^0-9])/i);

      return match ? Number(match[1] + (match[2] ? '.' + match[2] : '')) : null;
    }

    function isInStock(variant) {
      var policy = norm(variant.inventory_policy || variant.inventoryPolicy);
      if (policy === 'continue') return false;
      if (variant.available !== true && variant.availableForSale !== true) return false;

      var quantity = variant.inventory_quantity;
      if (quantity == null) quantity = variant.inventoryQuantity;
      if (quantity != null && quantity !== '' && Number.isFinite(Number(quantity)) && Number(quantity) <= 0) return false;

      return true;
    }

    function priceNumber(value) {
      var number = Number(value);
      if (!Number.isFinite(number)) return null;
      return number >= 100000 ? number / 100 : number;
    }

    function formatPrice(value) {
      var number = priceNumber(value);
      return number == null ? '' : '¥' + Math.round(number).toLocaleString('ja-JP');
    }

    function productImage(product) {
      if (product.image && product.image.src) return product.image.src;
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image && product.featured_image.src) return product.featured_image.src;
      if (Array.isArray(product.images) && product.images.length) return product.images[0].src || product.images[0];
      return '';
    }

    function makeCard(item) {
      var article = document.createElement('article');
      article.className = 'sbs-card';

      var link = document.createElement('a');
      link.className = 'sbs-card-link';
      link.href = '/products/' + encodeURIComponent(item.product.handle);

      var imageWrap = document.createElement('div');
      imageWrap.className = 'sbs-image-wrap';
      var src = productImage(item.product);
      if (src) {
        var image = document.createElement('img');
        image.className = 'sbs-image';
        image.src = src;
        image.alt = item.product.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        imageWrap.appendChild(image);
      }

      var body = document.createElement('div');
      body.className = 'sbs-card-body';

      var title = document.createElement('h3');
      title.className = 'sbs-card-title';
      title.textContent = item.product.title || '';

      var badges = document.createElement('div');
      badges.className = 'sbs-badges';
      item.sizes.forEach(function (size) {
        var badge = document.createElement('span');
        badge.className = 'sbs-badge';
        badge.textContent = size.toFixed(1) + 'cm';
        badges.appendChild(badge);
      });

      body.appendChild(title);
      body.appendChild(badges);

      if (item.price) {
        var price = document.createElement('p');
        price.className = 'sbs-price';
        price.textContent = item.price;
        body.appendChild(price);
      }

      link.appendChild(imageWrap);
      link.appendChild(body);
      article.appendChild(link);
      return article;
    }

    function buildGroups(products) {
      var groups = { u22: [], '225-230': [], '235-240': [], o245: [] };
      var seen = {};

      products.forEach(function (product) {
        if (!product || !product.handle || seen[product.handle] || isExcluded(product)) return;
        seen[product.handle] = true;

        var index = sizeOptionIndex(product);
        if (index < 0) return;

        var stocked = (product.variants || [])
          .filter(isInStock)
          .map(function (variant) {
            return { variant: variant, size: parseSize(variant, index) };
          })
          .filter(function (row) {
            return row.size != null;
          });

        if (!stocked.length) return;

        GROUPS.forEach(function (group) {
          var matches = stocked.filter(function (row) {
            return group.test(row.size);
          });
          if (!matches.length) return;

          var sizes = Array.from(new Set(matches.map(function (row) { return row.size; })))
            .sort(function (a, b) { return a - b; });
          var prices = matches
            .map(function (row) { return priceNumber(row.variant.price); })
            .filter(function (value) { return value != null; });

          groups[group.key].push({
            product: product,
            sizes: sizes,
            price: prices.length ? formatPrice(Math.min.apply(Math, prices)) : ''
          });
        });
      });

      return groups;
    }

    function render(groups) {
      GROUPS.forEach(function (group) {
        var items = groups[group.key] || [];
        items.sort(function (a, b) {
          return String(a.product.title).localeCompare(String(b.product.title), 'ja');
        });

        var grid = document.querySelector('[data-grid="' + group.key + '"]');
        var jumpCount = document.querySelector('[data-count-for="' + group.key + '"]');
        var sectionCount = document.querySelector('[data-section-count="' + group.key + '"]');
        var countText = items.length + '商品';

        if (jumpCount) jumpCount.textContent = countText;
        if (sectionCount) sectionCount.textContent = countText;
        if (!grid) return;

        grid.textContent = '';
        if (!items.length) {
          var empty = document.createElement('div');
          empty.className = 'sbs-empty';
          empty.textContent = '現在、このサイズでオンライン購入できる在庫はありません。';
          grid.appendChild(empty);
        } else {
          items.forEach(function (item) {
            grid.appendChild(makeCard(item));
          });
        }
      });

      var status = document.getElementById('sbs-status');
      var sections = document.getElementById('sbs-sections');
      if (status) status.hidden = true;
      if (sections) sections.hidden = false;
    }

    function collectionProducts(payload) {
      return Array.isArray(payload && payload.products) ? payload.products : [];
    }

    function fetchJson(url) {
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 12000) : null;

      return fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (timer) clearTimeout(timer);
        if (!response.ok) throw new Error('HTTP ' + response.status + ': ' + url);
        return response.json();
      }, function (error) {
        if (timer) clearTimeout(timer);
        throw error;
      });
    }

    var routeRoot = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';

    var requests = [
      fetchJson(routeRoot + 'collections/yui/products.json?limit=250'),
      fetchJson(routeRoot + 'collections/coshaer/products.json?limit=250'),
      fetchJson(routeRoot + 'collections/famzon-body/products.json?limit=250'),
      fetchJson(routeRoot + 'products/express-6cm.js')
    ];

    Promise.allSettled(requests).then(function (results) {
      var products = [];
      var successfulSources = 0;

      results.slice(0, 3).forEach(function (result) {
        if (result.status === 'fulfilled') {
          successfulSources += 1;
          products = products.concat(collectionProducts(result.value));
        } else {
          console.warn('Stock by size collection load failed:', result.reason);
        }
      });

      var expressResult = results[3];
      if (expressResult && expressResult.status === 'fulfilled') {
        successfulSources += 1;
        var expressProduct = expressResult.value && (expressResult.value.product || expressResult.value);
        if (expressProduct) products.push(expressProduct);
      } else if (expressResult) {
        console.warn('Stock by size express product load failed:', expressResult.reason);
      }

      if (!successfulSources) throw new Error('All stock data sources failed');
      render(buildGroups(products));
    }).catch(function (error) {
      console.error('Stock by size page:', error);
      var status = document.getElementById('sbs-status');
      if (status) {
        status.className = 'sbs-status is-error';
        status.innerHTML = '在庫情報を読み込めませんでした。ページを再読み込みするか、<a href="/collections/all">商品一覧</a>からご確認ください。';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockBySizePage, { once: true });
  } else {
    initStockBySizePage();
  }
})();
